module.exports = __webpack_public_path__ + "static/789456412.3e95f637.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/components/c-footer/img/789456412.png
// module id = 742
// module chunks = 2